define('views/ecards/ecard_group_slider',[
    'backbone',
    'views/_base/baseview',
    'text!views/ecards/ecard_group_slider.html',
    'views/ecards/ecard',
    'views/shop/instore/ecard_purchase',
    'models/merchants/giftcardconfig',
    'views/ecards/passkit',
    'views/shared/modal/modal_modern'
], function(Backbone, BaseView, Template, EcardView, EcardPurchaseView, EcardConfigModel, PassKitView, Modal){
    'use strict';

    return BaseView.extend({
        className: 'egiftcard-slider-inner-container',
        tagName  : 'div',
        isRender : false,
        needsAuth: false,
        template : _.template(Template),
        events   : {
            'click .js-egiftcards-previous': 'showPreviousEcard',
            'click .js-egiftcards-next'    : 'showNextEcard',
            'click .js-pagination-item'    : 'handlePaginationTap',
            'click .js-egiftcard-nearby-stores': 'showNearbyStores'
        },

        animate_time   : 300,
        ecard_width    : 351,
        ecard_index    : 0,
        ecard_total    : 0,
        ecard_container: 0,

        initialize: function(options){
            options = options || {};

            this.gcguid = null;
            this.data = options.data;
            this.header = options.header;
            this.wallet = options.wallet;
            this.merchant = options.merchant;
            this.loadEcards = options.loadEcards;
            this.self_contained = options.self_contained;
            this.calling_view_MODAL = options.calling_view_MODAL;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            this.$el.html(this.template());
        },

        loadData: function(){
            var that = this;

            this.render();
            this.addEcardCarousel();
            this.adjustButtonsDelay();

            if(this.header){

                this.loadEcardConfigData(function(){

                    that.addMerchantDetails();

                });

            }
        },

        loadEcardConfigData: function(callback){
            var that = this;

            this.ecard_config_model = new EcardConfigModel({ MGGUID: this.data.key });
            this.ecard_config_model.fetch().done(function(){
                callback();
            });
        },

        addMerchantDetails: function(){
            var data = this.ecard_config_model.toJSON(),
                agid = this.merchant.AggregatorID;
            
            $('.js-egiftcard-cashback').html(data.ConsumerRebatePercentage);

            if(agid == enums.aggregatorID.Blackhawk){
                var img = '<img src="img/icons/ecard-payment-icon.png" alt="eCard Payment" />';
            } else if(agid == enums.aggregatorID.Empyr){
                var img = '<img src="img/icons/swipe-payment-icon.png" alt="Swipe Payment" />';
            } else if(agid == enums.aggregatorID.Print){
                var img = '<img src="img/icons/print-payment-icon.png" alt="Print Payment" />';
            }

            $('.js-egiftcard-payment-type').html(img);

        },

        addEcardCarousel: function(){
            var that = this,
                ecards = this.data.ecards;

            this.ecard_total = ecards.length;
            this.ecard_container = (ecards.length*this.ecard_width);

            this.$el.find('.js-egiftcards-slider-list').css({ width: this.ecard_container + 'px' });

            for(var i = 0; i < ecards.length; i++){
                var ecard = ecards[i];
                var ecard_card = new EcardView({ ecard: ecard, parent_view: this });

                this.gcguid = ecard.GiftCardGUID;
                
                ecard_card.$el.addClass('ecardguid-'+ecard.GiftCardGUID);

                this.$el.find('.js-egiftcards-slider-list').append(ecard_card.el);

                if(this.ecard_total > 1){
                    this.$el.find('.egiftcards-slider-pagination').append('<li' + ((i == 0) ? ' class="active"' : '') + '><a href="#" class="js-pagination-item">&#160;</a></li>');
                }

            }

            // Temporary fix
            setTimeout(function(){

                $('.js-egiftcard-nearby-stores').on('click',function(){

                    // that.calling_view_MODAL.closeMODAL();
                    pf.navigate('shop/nearby/'+that.data.key);

                });

                $('.js-egiftcard-purchase').on('click',function(){

                    if(that.self_contained){
                        that.showEcardPurchaseMODAL();
                    } else {
                        that.calling_view_MODAL.showEcardPurchaseActionViewMODAL();
                    }
                    
                });

                $('.ecard-container').on('click', function(e){
                    if(e && e.preventDefault){ e.preventDefault(); }
                    if(e && e.stopPropagation){ e.stopPropagation(); }

                    var class_list = $(e.currentTarget).attr('class').split(/\s+/);
                        
                    class_list.forEach(function(classname){

                        if(classname.indexOf('ecardguid-') >= 0){
                            var gcguid = classname.slice(classname.indexOf('-')+1);

                            that.gcguid = gcguid;

                            if(gcguid){
                                that.showEcardMODAL(gcguid);
                            }
                        }

                    });
                    
                });

            }, 300);

        },

        showButtons: function(){
            if(this.ecard_total > 1){
                this.showNextBtn();
            }
        },

        adjustButtonsDelay: function(){
            var that = this;

            setTimeout(function(){
                that.adjustButtons();
            },300);
        },

        adjustButtons: function(){

            if(this.ecard_index >= 0){

                if(!this.isNextBtnVisible()){
                    this.showNextBtn();
                }

                if(this.ecard_index == (this.ecard_total - 1)){
                    this.hideNextBtn();
                }

                if(this.ecard_index < this.ecard_total){
                    if(!this.isPreviousBtnVisible()){
                        this.showPreviousBtn();
                    }
                }

                if(this.ecard_index == 0){
                    this.hidePreviousBtn();
                }
                
            }
                
        },

        isNextBtnVisible: function(){
            return $('.js-egiftcards-next').is(":visible");
        },

        showNextBtn: function(){
            $('.js-egiftcards-next').show();
        },

        hideNextBtn: function(){
            $('.js-egiftcards-next').hide();
        },

        isPreviousBtnVisible: function(){
            return $('.js-egiftcards-previous').is(":visible");
        },

        showPreviousBtn: function(){
            $('.js-egiftcards-previous').show();
        },

        hidePreviousBtn: function(){
            $('.js-egiftcards-previous').hide();
        },

        showNextEcard: function(){
            var new_position = this.ecard_index + 1;
            
            if(new_position < this.ecard_total){

                this.ecard_index = new_position;

                this.updateCarousel('-');

            }

        },

        showPreviousEcard: function(){
            var new_position = this.ecard_index - 1;

            if(new_position >= 0){

                this.ecard_index = new_position;

                this.updateCarousel('+');

            }

        },

        updateCarousel: function(direction){
            $('.js-egiftcards-slider-list').animate({ marginLeft: direction + '=' + this.ecard_width + 'px' }, this.animate_time);

            this.adjustButtons();
            this.adjustPagination();
        },

        handlePaginationTap: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }
            
            var page = $(e.target).parent(),
                page_position = page.index();

            if(!page.hasClass('active')){

                if(page_position == 0){
                    var offset = '0px';
                } else {
                    var offset = '-' + this.ecard_width * page_position + 'px';
                }

                this.ecard_index = page_position;

                this.adjustPagination();

                this.adjustButtons();

                $('.js-egiftcards-slider-list').animate({ marginLeft: offset }, this.animate_time);
                
            }

        },

        adjustPagination: function(){
            $('.egiftcards-slider-pagination li').removeClass('active');

            $('.egiftcards-slider-pagination').find('li').eq(this.ecard_index).addClass('active');
        },

        showEcardMODAL: function(gcguid){
            var ecards = this.data.ecards;
            
            for(var i = 0; i < ecards.length; i++){
                var ecard = ecards[i];

                if(ecard.GiftCardGUID == this.gcguid){

                    // this.calling_view_MODAL.closeMODAL();

                    this.showPasskit();

                    // pf.navigate('merchants/groups/'+ecard.MerchantGroupGUID+'/ecard/'+ecard.MerchantGUID+'/'+ecard.GiftCardGUID);

                }

            }
        },

        showEcardPurchaseMODAL: function(){
            var that = this;

            if(!this.ecard_purchase){

                var data = (this.data) ? this.data : null,
                    ecard_data = (this.ecard_config_model) ? this.ecard_config_model.toJSON() : null;

                if(data.AggregatorID == enums.aggregatorID.Print){
                    var print = true;
                } else {
                    var print = false;
                }

                if(ecard_data && data){

                    this.ecard_purchase = new EcardPurchaseView({
                        print      : print,
                        wallet     : this.wallet,
                        loadEcards : this.loadEcards,
                        merchant   : data,
                        ecard_data : ecard_data,
                        ecard_total: this.ecard_total,
                        parent_view: this,
                        elementName: '.egiftcards-slider-merchant-group-action'
                    });

                }

            }

            $('.egiftcards-slider-container').fadeOut(300, function(){
                $('.egiftcards-slider-merchant-group-action').fadeIn();
            });
            
        },

        showPasskit: function(gcguid){
            var data = (this.data) ? this.data : null,
                ecard_data = (this.ecard_config_model) ? this.ecard_config_model.toJSON() : null;

            // Close the existing Modal before showing the next one
            // this.closeMODAL();

            this.passkit = new PassKitView({
                data              : this.data,
                gcguid            : this.gcguid,
                header            : this.header,
                wallet            : this.wallet,
                merchant          : this.merchant,
                self_contained    : this.self_contained,
                parent_view_MODAL : this,
                calling_view_MODAL: this.calling_view_MODAL
            });
                
            var passkit_modal = new Modal({
                show        : true,
                content     : this.passkit.$el.html(),
                calling_view: this.passkit
            });

        },

        showEcardsMODAL: function(){
            var that = this;

            $('.egiftcards-slider-merchant-group-action').fadeOut(300, function(){
                $('.egiftcards-slider-container').fadeIn();
            });
            
        },

        // closeMODAL: function(){
        //     $('#pf-modal-modern').fadeOut(function(){
        //         $('#pf-modal-modern').remove();
        //     });
        // },

        close: function(){}
    });
});
